module.exports = __webpack_public_path__ + "static/media/wb-sm.44d29495.png";